import React from "react";
import * as Mui from "@mui/material";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import { saveIntegration } from "redux/slice/integrations";
import { Integration } from "model/integration";
import { CopyField } from "../copy-field";
import { SimpleIntegrationModal } from "../../simple-integration-modal";

const mapStateToProps = (_state: RootState) => ({});
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ saveIntegration }, dispatch);

interface OwnProps {
	open: boolean;
	onClose: () => void;
	integration: Integration;
	name?: string;
	onNameChange: (name: string) => void;
}

interface Props extends OwnProps, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {}

class Component extends React.Component<Props> {

	public render() {
		const { open, onClose, integration, name, onNameChange, saveIntegration } = this.props;

		return (
			<SimpleIntegrationModal open={open} onClose={onClose} integration={integration}>
				<Mui.Grid container direction="column" spacing={2}>
					<Mui.Grid item>
						<Mui.TextField
							label="Name" placeholder={integration.integrationType.name}
							value={name || ""} onChange={e => onNameChange(e.target.value)}
							fullWidth margin="dense" variant="outlined"
						/>
					</Mui.Grid>
					<Mui.Grid item>
						<CopyField label="Email Address" value={integration.data.externalKey as string || ""}
							fullWidth margin="dense" variant="outlined" />
					</Mui.Grid>
					<Mui.Grid item>
						<Mui.Button variant="contained" color="primary"
							onClick={() => saveIntegration({ integration: { ...integration, name } })}>
							Save
						</Mui.Button>
					</Mui.Grid>
				</Mui.Grid>
			</SimpleIntegrationModal>
		);
	}

}

export const LeadAggregationModal = connect(mapStateToProps, mapDispatchToProps)(Component);
